import React from "react";
import { DataGrid, esES } from "@mui/x-data-grid";
import GetAppIcon from "@mui/icons-material/GetApp";
import { procesosResources } from "../endpoints";
import SnackbarAlert from "./SnackbarAlert";
import useToken from "../useToken";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

class TablaProcesos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: [],
            loading: true,
            paginationModel: { page: 0, pageSize: 10 },
            totalCount: 0,
            openSnack: false,
            severity: "",
            message: "",
            user: useToken.getUser(),
            search: "",
        };
    }

    componentDidMount() {
        this.getProcesos();
    }

    getProcesos = () => {
        const { paginationModel, search } = this.state;
        const { page, pageSize } = paginationModel;

        this.setState({ loading: true, openSnack: false });

        procesosResources
            .getProcesos(page + 1, pageSize, search)
            .then((res) => res.json())
            .then((result) => {
                if (result.status_code === 401) {
                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        message: result.message,
                        loading: false,
                    });
                } else {
                    this.setState({
                        datos: result.items.map((item, index) => ({ id: index, ...item })),
                        totalCount: result.total,
                        loading: false,
                    });
                }
            })
            .catch((err) => console.log(err));
    };

    handlePaginationChange = (newModel) => {
        this.setState({ paginationModel: newModel }, () => this.getProcesos());
    };

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState(
            { search: value, paginationModel: { ...this.state.paginationModel, page: 0 } },
            () => this.getProcesos()
        );
    };

    getArchivoResultado = (ruta) => {
        if (!ruta) return;
        const link = document.createElement("a");
        link.href = `/static${ruta}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        const { datos, paginationModel, totalCount, loading, openSnack, severity, message, search } =
            this.state;

        const columns = [
            { field: "id", headerName: "N°", flex: 1, minWidth: 80,},
            { field: "descripcion", headerName: "Descripción", flex: 1, minWidth: 230, },
            {
                field: "inicio",
                headerName: "Inicio",
                flex: 1, minWidth: 150,
                valueFormatter: (params) => {
                    const d = new Date(params.value);
                    if (isNaN(d)) return "";
                    const pad = (n) => n.toString().padStart(2, "0");
                    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
                        d.getHours()
                    )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                },
            },
            {
                field: "duracion",
                headerName: "Duración (s)",
                flex: 1, minWidth: 130,
                valueFormatter: (params) =>
                    params.value === null ? "--" : (Math.floor(params.value * 100) / 100).toFixed(1),
            },
            {
                field: "estado",
                headerName: "Estado",
                flex: 1, minWidth: 120,
                cellClassName: (params) =>
                    params.value === "Finalizado"
                        ? "celda-verde"
                        : params.value === "Error"
                            ? "celda-roja"
                            : "",
            },
            {
                field: "resultado",
                headerName: "Descargar",
                flex: 1, minWidth: 90,
                sortable: false,
                renderCell: (params) => (
                    <GetAppIcon
                        style={{ cursor: params.value ? "pointer" : "not-allowed" }}
                        onClick={() => this.getArchivoResultado(params.value)}
                    />
                ),
            },
        ];

        return (
            <div style={{ height: 680, width: "100%" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <TextField
                        label="Buscar"
                        variant="outlined"
                        size="small"
                        value={search}
                        onChange={this.handleSearchChange}
                    />
                </Box>

                <DataGrid
                    rows={datos}
                    columns={columns}
                    pagination
                    paginationMode="server"
                    rowCount={totalCount}
                    loading={loading}
                    getRowId={(row) => row.id}
                    pageSizeOptions={[10]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={this.handlePaginationChange}
                    disableColumnMenu
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                    autoHeight
                />

                {openSnack && <SnackbarAlert severity={severity} message={message} />}

                <style>
                    {`
                        .celda-verde { background-color: #3EB415; color: black; }
                        .celda-roja { background-color: #d32f2f; color: black; }
                    `}
                </style>
            </div>
        );
    }
}

export default TablaProcesos;
